import React from 'react';
import { Card, Flex } from 'antd';
import { DailyLdmRing } from './daily-ldm-ring/daily-ldm-ring';
import styles from './daily-ldm-rings.module.scss';
import type { IDailyLdmRingsProps } from './types';

export const DailyLdmRings: React.FC<IDailyLdmRingsProps> = (props) => {
  const { data, ldmGoal, weightGoal } = props;
  return (
    <Card title='Daily load goals by week'>
      <Flex justify='space-around' align='center' className={styles.ringsContainer}>
        {data.map((item) => (
          <DailyLdmRing
            key={item.date}
            dayLabel={item.dayLabel}
            date={item.date}
            ldmValue={item.ldmValue}
            weightValue={item.weightValue}
            ldmGoal={ldmGoal}
            weightGoal={weightGoal}
          />
        ))}
      </Flex>
    </Card>
  );
};
